module.exports = __webpack_public_path__ + "img/sms-icon.53e67158.svg";